import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=7580af85&scoped=true"
import script from "./SupportPage.vue?vue&type=script&lang=js"
export * from "./SupportPage.vue?vue&type=script&lang=js"
import style0 from "./SupportPage.vue?vue&type=style&index=0&id=7580af85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7580af85",
  null
  
)

export default component.exports